var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "c-games_gameListHeader_sort" },
    _vm._l(_vm.orderTypes, function(orderType, index) {
      return _c(
        "li",
        {
          key: "orderType_" + index,
          staticClass: "c-games_gameListHeader_order"
        },
        [
          _c("label", { staticClass: "c-games_gameListHeader_orderLabel" }, [
            _c("input", {
              staticClass: "c-games_gameListHeader_inputElement",
              attrs: { type: "radio", name: "orderType" },
              domProps: {
                checked: orderType === _vm.currentOrderType,
                value: orderType
              },
              on: { change: _vm.onChange }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "c-games_gameListHeader_labelElement" }, [
              _vm._v(_vm._s(orderType))
            ]),
            _vm._v(" "),
            _c("i", { staticClass: "c-games_gameListHeader_indicatorElement" })
          ])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4eb0ca0b", { render: render, staticRenderFns: staticRenderFns })
  }
}